import axios from 'axios';

const API = '/api';

const ADMIN_LS_KEY = 'plixy_admin_pwd';

export const setAdminPassword = (pwd) =>
  sessionStorage.setItem(ADMIN_LS_KEY, pwd);

export const getAdminPassword = () =>
  sessionStorage.getItem(ADMIN_LS_KEY) || '';

export const clearAdminPassword = () =>
  sessionStorage.removeItem(ADMIN_LS_KEY);

const adminHeaders = () => ({
  headers: {
    'X-Admin-Password': getAdminPassword(),
  },
});

export const api = {
  // Public Settings
  getPublicSettings: () =>
    axios
      .get(`${API}/settings/public`)
      .then((r) => r.data),

  // Admin Login
  adminLogin: (password) =>
    axios
      .post(`${API}/admin/login`, { password })
      .then((r) => r.data),

  // Admin Settings
  adminSettings: () =>
    axios
      .get(`${API}/admin/settings`, adminHeaders())
      .then((r) => r.data),

  updateSettings: (payload) =>
    axios
      .put(`${API}/admin/settings`, payload, adminHeaders())
      .then((r) => r.data),
};
